
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.927 9.988a.278.278 0 01-.277.27H7.31a.277.277 0 01-.277-.277V8.839c0-.748.64-1.092 1.102-1.342.688-.372.976-.599.976-1.04A1.146 1.146 0 007.978 5.3a1.56 1.56 0 00-1.321.855.14.14 0 01-.189.05l-1.396-.8a.142.142 0 01-.051-.197 3.429 3.429 0 012.96-1.797 3.04 3.04 0 013.022 3.046C11 8.097 9.453 8.568 9.031 9.159a2.64 2.64 0 00-.104.829zm-.95 3.688c-.651 0-1.18-.53-1.18-1.184 0-.654.529-1.184 1.18-1.184a1.183 1.183 0 01.001 2.368zM9.922.773a8 8 0 102.603 14.363l3.248 1.174-1.174-3.248A8 8 0 009.921.773z"}})])
          )
        }
      }
    